import React, { useEffect, useState, useRef } from 'react';
import { Play, Pause, Volume2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function AudioPreview() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleTimeUpdate = () => {
    if (audioRef.current) {
      const current = audioRef.current.currentTime;
      const duration = audioRef.current.duration || 1;
      setProgress(current / duration * 100);
    }
  };
  const handleEnded = () => {
    setIsPlaying(false);
    setProgress(0);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 2.5,
    duration: 0.8
  }} className="w-full max-w-sm mb-6" data-id="element-27">
      <div className="bg-brand-navy/60 backdrop-blur-md border border-brand-indigo/30 rounded-xl p-3 flex items-center gap-3 shadow-lg" data-id="element-28">
        <button onClick={togglePlay} className="w-10 h-10 rounded-full bg-brand-indigo flex items-center justify-center flex-shrink-0 hover:bg-brand-indigo/80 transition-colors shadow-[0_0_15px_rgba(67,56,202,0.4)]" data-id="element-29">
          {isPlaying ? <Pause size={18} className="text-white fill-white" data-id="element-30" /> : <Play size={18} className="text-white fill-white ml-0.5" data-id="element-31" />}
        </button>

        <div className="flex-1 min-w-0" data-id="element-32">
          <div className="flex justify-between items-center mb-1" data-id="element-33">
            <span className="text-xs font-bold text-brand-amber uppercase tracking-wider flex items-center gap-1" data-id="element-34">
              <Volume2 size={10} data-id="element-35" /> Escucha un adelanto
            </span>
            <span className="text-[10px] text-slate-400 font-mono" data-id="element-36">0:22</span>
          </div>

          <div className="relative w-full h-1.5 bg-brand-dark/50 rounded-full overflow-hidden" data-id="element-37">
            <motion.div className="absolute top-0 left-0 h-full bg-gradient-to-r from-brand-indigo to-brand-amber" style={{
            width: `${progress}%`
          }} data-id="element-38" />
          </div>
        </div>

        <audio ref={audioRef} src="https://cdn.magicpatterns.com/uploads/iDJPaC3vyqTH2pETno7zdX/76e48247-d334-4f1d-9553-bfbbbed801f8.mp4" onTimeUpdate={handleTimeUpdate} onEnded={handleEnded} data-id="element-39" />
      </div>
    </motion.div>;
}